<script>
import BoxProductCart from "@/components/cart/boxProductCart.vue";
import {useAuthStore} from "@/stores/auth";
import {mapStores} from "pinia";
import OrderSummary from "@/components/cart/OrderSummary.vue";

export default {
  name: 'ViewCart',
  components: {OrderSummary, BoxProductCart},
  computed: {
  ...mapStores(useAuthStore)
  }
}
</script>

<template>
  <section class="bg-white py-8 antialiased dark:bg-gray-900 md:py-16">
    <div v-if="authStore.getCart && authStore.getCart?.productsCart?.length > 0" class="mx-auto max-w-screen-xl px-4 2xl:px-0">
      <h2 class="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">Mon panier</h2>

      <div class="mt-6 sm:mt-8 md:gap-6 lg:flex lg:items-start xl:gap-8">
        <div class="mx-auto w-full flex-none lg:max-w-2xl xl:max-w-4xl">
          <div class="space-y-6">
            <box-product-cart v-for="(productCart, index) in authStore.getCart.productsCart" :key="index" :product-cart="productCart" />
          </div>
        </div>
        <order-summary :products-cart="authStore.getCart.productsCart" />
      </div>
    </div>
    <div v-else class="flex items-center justify-center flex-col">
      <img src="../../assets/empty-cart.png" alt="Image panier vide">
    </div>
  </section>
</template>
